// Libraries
import React from 'react';

// Supermove
import {Styled, Icon, PreventPropagation} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {usePopover, useModal} from '@supermove/hooks';
import {RefundModel} from '@supermove/models';
import {colors} from '@supermove/styles';

// App
import ActionMenuPopover from '@shared/design/components/ActionMenu/ActionMenuPopover';
import TertiaryButton from '@shared/design/components/Button/TertiaryButton';
import PaymentMethodKind from '@shared/modules/PaymentMethod/enums/PaymentMethodKind';
import DeleteRefundModal from 'modules/Refund/components/DeleteRefundModal';

const Row = Styled.View`
  flex-direction: row;
  align-items: center;
`;

const RefundPaymentAction = ({refund, refetch}: {refund: RefundModel; refetch: () => void}) => {
  const paymentActionsPopover = usePopover();
  const deleteRefundModal = useModal({name: 'Delete Refund Modal'});
  const isPayengineCreditCard = refund.payment.method === PaymentMethodKind.PAYENGINE_CREDIT_CARD;

  return (
    <Row style={{justifyContent: 'center'}}>
      <PreventPropagation>
        <ActionMenuPopover
          popover={paymentActionsPopover}
          placement={ActionMenuPopover.Position.LeftStart}
          width={200}
          actions={[
            {
              text: 'Delete',
              onPress: () => {
                paymentActionsPopover.handleClose();
                deleteRefundModal.handleOpen();
              },
              color: colors.red.warning,
            },
          ]}
        >
          <TertiaryButton
            isDisabled={isPayengineCreditCard}
            onPress={paymentActionsPopover.handleToggle}
            style={{paddingHorizontal: 8}}
          >
            <Icon
              source={Icon.EllipsisV}
              size={16}
              color={isPayengineCreditCard ? colors.gray.border : colors.gray.secondary}
            />
          </TertiaryButton>
        </ActionMenuPopover>
        <DeleteRefundModal
          isOpen={deleteRefundModal.isOpen}
          handleClose={deleteRefundModal.handleClose}
          refund={refund}
          refetch={refetch}
        />
      </PreventPropagation>
    </Row>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
RefundPaymentAction.fragment = gql`
  ${DeleteRefundModal.fragment}

  fragment RefundPaymentAction on Refund {
    id
    payment {
      id
      method
    }
    ...DeleteRefundModal
  }
`;

export default RefundPaymentAction;
